interface ApiResult {
    ok: boolean,
    response: any,
    problem: any,
}

export class ApiClient {

    // public fetch = require("fetch-cookie/node-fetch")(require('node-fetch'));
    private hostname = "";

    public execute(method: string, request: any = {}): Promise<any> {

        const init: RequestInit = {
            method: 'post',
            body: JSON.stringify(request, null, 2),
            credentials: "same-origin",
        };

        return fetch(`${this.hostname}/api/rpc/${method}`, init)
            .then(res => res.json())
            .then((result: ApiResult) => {
                // console.log(`${method} request:`);
                // console.log(init.body);
                if (result.ok) {
                    // console.log(`${method} response:`);
                    // console.log(JSON.stringify(result.response, null, 2));
                    return result.response;
                } else {
                    // console.error(`${method} problem:`);
                    // console.error(JSON.stringify(result.problem, null, 2));
                    throw result.problem;
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/api/api-client.ts